import { CREATE_VENDOR_AGENT, CREATE_VENDOR_AGENT_SUCCESS, CREATE_VENDOR_AGENT_ERROR, CREATE_VENDOR_AGENT_EMPTY } from './../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CreateVendorAgent = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_VENDOR_AGENT:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CREATE_VENDOR_AGENT_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case CREATE_VENDOR_AGENT_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CREATE_VENDOR_AGENT_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CreateVendorAgent;
